import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import store from 'slices/store';
import Loading from 'components/loading';
import MessageModal from 'components/messageModals/messageModal';
import ToastModal from 'components/messageModals/toastModal';
import LeaveConfirmModal from 'components/messageModals/leaveConfirmModal';
import EcTimeoutModal from 'components/messageModals/ecTimeoutModal';
import ScrollToTop from 'components/scrollTop';
import TopPage from 'pages/topPage';
import ShopSelect from 'pages/reservation/shopSelect';
import ShopAndServiceSelect from 'pages/reservation/shopAndServiceSelect';
import DateSelect from 'pages/reservation/dateSelect';
import Confirm from 'pages/reservation/confirm';
import Complete from 'pages/reservation/complete';
import ReservationList from 'pages/reservation/list';
import Fusei from 'pages/reservation/fusei';
import PitService from 'pages/pitService';
import KarteDescription from 'pages/karte/karteDescription';
import Karte from 'pages/karte/karte';
import FAQ from 'pages/faq/faq';
import Maintenance from 'pages/maintenance/maintenance';
import Terms from 'pages/terms/terms';
import Path from 'constants/routePath';
import Lisener from 'components/lisener/index';
import './App.scss';
import RootRoute from './routes/rootRoute';
import GuestReservation from 'pages/guestReservation/guestReservation';
import GuestShopAndDateSelect from 'pages/guestReservation/guestShopAndDateSelect';
import GuestCarInfo from 'pages/guestReservation/guestCarInfo';
import GuestUserInfo from 'pages/guestReservation/guestUserInfo';
import GuestConfirm from 'pages/guestReservation/guestConfirm';
import GuestComplete from 'pages/guestReservation/guestComplete';
import GuestError from 'pages/guestReservation/guestError';
import GuestSearch from 'pages/guestReservation/guestSearch';
import GuestInfo from 'pages/guestReservation/guestInfo';

const App = () => {
  const path = [
    // ログイン状態にかかわらず遷移できる画面
    { path: Path.FAQ, element: <FAQ /> },
    { path: Path.MAINTENANCE, element: <Maintenance /> },
    { path: Path.PIT_SERVICE, element: <PitService /> },
    { path: Path.TOP, element: <TopPage /> },
    { path: Path.TERMS, element: <Terms /> },
    { path: Path.RESERVATION_FUSEI, element: <Fusei /> },
    // 未ログイン時に遷移できる画面
    { path: Path.KARTE_DESCRIPTION, element: <KarteDescription /> },
    { path: Path.GUEST_RESERVATION, element: <GuestReservation /> },
    {
      path: Path.GUEST_SHOP_AND_DATE_SELECT,
      element: <GuestShopAndDateSelect />,
    },
    { path: Path.GUEST_CAR_INFO, element: <GuestCarInfo /> },
    { path: Path.GUEST_USER_INFO, element: <GuestUserInfo /> },
    { path: Path.GUEST_CONFIRM, element: <GuestConfirm /> },
    { path: Path.GUEST_COMPLETE, element: <GuestComplete /> },
    { path: Path.GUEST_ERROR, element: <GuestError /> },
    { path: Path.GUEST_SEARCH, element: <GuestSearch /> },
    { path: Path.GUEST_INFO, element: <GuestInfo /> },
    // ログイン時に遷移できる画面
    { path: Path.KARTE, element: <Karte /> },
    { path: Path.RESERVATION_SHOP_SELECT, element: <ShopSelect /> },
    {
      path: Path.RESERVATION_SERVICE_SELECT,
      element: <ShopAndServiceSelect />,
    },
    { path: Path.RESERVATION_DATE_SELECT, element: <DateSelect /> },
    { path: Path.RESERVATION_CONFIRM, element: <Confirm /> },
    { path: Path.RESERVATION_COMPLETE, element: <Complete /> },
    { path: Path.RESERVATION_LIST, element: <ReservationList /> },
  ];

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Lisener />
        <ScrollToTop />
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        {/* <Suspense fallback={null}> */}

        <Routes>
          <Route exact element={<RootRoute />}>
            {path.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}

            {/* 存在しないパスが指定された */}
            <Route path="*" element={<Navigate to={Path.TOP} replace />} />
          </Route>
        </Routes>
        {/* </Suspense> */}
      </BrowserRouter>
      <Loading />
      <ToastModal />
      <MessageModal />
      <LeaveConfirmModal />
      <EcTimeoutModal />
    </Provider>
  );
};

export default App;
